/**
 * De default mapIndex die wordt gebruikt in 2D kaarten
 */
export const DEFAULT_MAPINDEX = "_DEFAULT_";

/**
 * De default mapIndex die wordt gebruikt in 3D kaarten (Cesium)
 */
export const DEFAULT_CESIUM_MAPINDEX = "_DEFAULT_CESIUM_";
